import { render, staticRenderFns } from "./SprPassword.vue?vue&type=template&id=4e867576&scoped=true"
import script from "./SprPassword.vue?vue&type=script&lang=ts"
export * from "./SprPassword.vue?vue&type=script&lang=ts"
import style0 from "./SprPassword.vue?vue&type=style&index=0&id=4e867576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e867576",
  null
  
)

export default component.exports